import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface BorrInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function BorrInternalControls({ onBack, setActiveSection, controlsListSection }: BorrInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Borrowings"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}


